import script from "./AddPromoCode.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPromoCode.vue?vue&type=script&setup=true&lang=js"

import "./AddPromoCode.vue?vue&type=style&index=0&id=dd48316a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd48316a"]])

export default __exports__